 (function () {

    /*
      This snippet can appear on multiple product cards.

      Initialise global event listeners only once.
    */

    if (window.notifyMePopupInitialized) return;

    window.notifyMePopupInitialized = true;

    let activeOverlay = null;
    let activeTrigger = null;


    /* =========================================================
       HELPERS
       ========================================================= */

    function getOverlay(variantId) {

      return document.getElementById(
        'notify-overlay-' + String(variantId)
      );

    }


    function getTrigger(variantId) {

      return document.querySelector(
        '[data-notify-open="' +
        String(variantId) +
        '"]'
      );

    }


    function lockPageScroll() {

      document.documentElement.classList.add(
        'notify-popup-open'
      );

      document.body.classList.add(
        'notify-popup-open'
      );

    }


    function unlockPageScroll() {

      document.documentElement.classList.remove(
        'notify-popup-open'
      );

      document.body.classList.remove(
        'notify-popup-open'
      );

    }


    /* =========================================================
       OPEN POPUP
       ========================================================= */

    function openNotifyPopup(
      variantId,
      trigger
    ) {

      const overlay =
        getOverlay(variantId);

      if (!overlay) return;


      /*
        Close another Notify Me popup
        before opening this one.
      */

      if (
        activeOverlay &&
        activeOverlay !== overlay
      ) {

        closeNotifyPopup(
          activeOverlay.dataset.notifyOverlay,
          false
        );

      }


      activeOverlay = overlay;

      activeTrigger =
        trigger ||
        getTrigger(variantId);


      /*
        IMPORTANT:
        Move ONLY the overlay to document.body.

        This guarantees that:
        - position:fixed uses viewport
        - card overflow cannot clip modal
        - card transforms cannot trap modal

        The Notify Me button stays inside
        the individual product card.
      */

      if (
        overlay.parentElement !==
        document.body
      ) {

        document.body.appendChild(
          overlay
        );

      }


      overlay.hidden = false;


      if (activeTrigger) {

        activeTrigger.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      lockPageScroll();


      /*
        CORRECTION:
        Focus first field = NAME,
        because it is now required.
      */

      window.requestAnimationFrame(
        function () {

          const nameInput =
            overlay.querySelector(
              'input[name="name"]'
            );

          const popupBox =
            overlay.querySelector(
              '.notify-box'
            );


          if (nameInput) {

            nameInput.focus({
              preventScroll: true
            });

          } else if (popupBox) {

            popupBox.focus({
              preventScroll: true
            });

          }

        }
      );

    }


    /* =========================================================
       CLOSE POPUP
       ========================================================= */

    function closeNotifyPopup(
      variantId,
      returnFocus
    ) {

      const overlay =
        getOverlay(variantId);

      if (!overlay) return;


      overlay.hidden = true;


      const trigger =
        getTrigger(variantId) ||
        activeTrigger;


      if (trigger) {

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      unlockPageScroll();


      if (
        returnFocus !== false &&
        trigger
      ) {

        trigger.focus({
          preventScroll: true
        });

      }


      if (
        activeOverlay === overlay
      ) {

        activeOverlay = null;

      }


      activeTrigger = null;

    }


    /* =========================================================
       MESSAGES
       ========================================================= */

    function showMessage(
      element,
      text,
      type
    ) {

      if (!element) return;


      element.textContent = text;

      element.className =
        'notify-msg';


      if (type) {

        element.classList.add(
          type
        );

      }

    }


    /* =========================================================
       SUBMITTING STATE
       ========================================================= */

    function setSubmitting(
      button,
      submitting
    ) {

      if (!button) return;


      const normalText =
        button.querySelector(
          '.notify-submit-text'
        );


      const loadingText =
        button.querySelector(
          '.notify-submit-loading'
        );


      button.disabled =
        submitting;


      button.setAttribute(
        'aria-busy',
        submitting
          ? 'true'
          : 'false'
      );


      if (normalText) {

        normalText.hidden =
          submitting;

      }


      if (loadingText) {

        loadingText.hidden =
          !submitting;

      }

    }


    /* =========================================================
       VALIDATION
       ========================================================= */

    function isValidEmail(email) {

      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        email
      );

    }


    /*
      CORRECTION:
      Name validation added.

      Requirements:
      - cannot be blank
      - minimum 2 characters
      - contains at least one letter

      This allows names such as:
      Vivek
      A K
      R. Sharma
      Anne-Marie
    */

    function isValidName(name) {

      if (!name) {
        return false;
      }


      if (name.length < 2) {
        return false;
      }


      /*
        At least one alphabet character.
      */
      if (!/[A-Za-z]/.test(name)) {
        return false;
      }


      return true;

    }


    /* =========================================================
       SUBMIT NOTIFICATION
       ========================================================= */

    async function submitNotifyForm(
      form
    ) {

      const messageElement =
        form.querySelector(
          '.notify-msg'
        );


      const submitButton =
        form.querySelector(
          '.notify-submit'
        );


      const nameInput =
        form.querySelector(
          '[name="name"]'
        );


      const emailInput =
        form.querySelector(
          '[name="email"]'
        );


      const name =
        nameInput
          ? nameInput.value.trim()
          : '';


      const email =
        emailInput
          ? emailInput.value.trim()
          : '';


      /*
        Reset previous validation states.
      */

      if (nameInput) {

        nameInput.classList.remove(
          'notify-input-error'
        );

      }


      if (emailInput) {

        emailInput.classList.remove(
          'notify-input-error'
        );

      }


      /* -------------------------------------------------------
         NAME REQUIRED
         ------------------------------------------------------- */

      if (!name) {

        if (nameInput) {

          nameInput.classList.add(
            'notify-input-error'
          );


          nameInput.focus();

        }


        showMessage(
          messageElement,
          'Please enter your name.',
          'error'
        );


        return;

      }


      /* -------------------------------------------------------
         NAME VALIDATION
         ------------------------------------------------------- */

      if (
        !nameInput.checkValidity() ||
        !isValidName(name)
      ) {

        nameInput.classList.add(
          'notify-input-error'
        );


        nameInput.focus();


        showMessage(
          messageElement,
          'Please enter a valid name.',
          'error'
        );


        return;

      }


      /* -------------------------------------------------------
         EMAIL REQUIRED
         ------------------------------------------------------- */

      if (!email) {

        if (emailInput) {

          emailInput.classList.add(
            'notify-input-error'
          );


          emailInput.focus();

        }


        showMessage(
          messageElement,
          'Please enter your email address.',
          'error'
        );


        return;

      }


      /* -------------------------------------------------------
         EMAIL VALIDATION
         ------------------------------------------------------- */

      if (
        !emailInput.checkValidity() ||
        !isValidEmail(email)
      ) {

        emailInput.classList.add(
          'notify-input-error'
        );


        emailInput.focus();


        showMessage(
          messageElement,
          'Please enter a valid email address.',
          'error'
        );


        return;

      }


      /* -------------------------------------------------------
         SUBMIT
         ------------------------------------------------------- */

      setSubmitting(
        submitButton,
        true
      );


      showMessage(
        messageElement,
        '',
        ''
      );


      try {

        const response =
          await fetch(
            form.dataset.workerUrl,
            {

              method: 'POST',

              headers: {

                'Content-Type':
                  'application/json'

              },

              body: JSON.stringify({

                type:
                  'subscription',

                name:
                  name,

                email:
                  email,

                productId:
                  String(
                    form.dataset.productId
                  ),

                variantId:
                  String(
                    form.dataset.variantId
                  ),

                productTitle:
                  form.dataset.productTitle,

                productUrl:
                  form.dataset.productUrl

              })

            }
          );


        let result = {};


        try {

          result =
            await response.json();

        } catch (jsonError) {

          throw new Error(
            'The server returned an invalid response.'
          );

        }


        if (!response.ok) {

          throw new Error(
            result.error ||
            'The subscription request failed.'
          );

        }


        if (
          result.success &&
          result.status ===
          'already_subscribed'
        ) {

          showMessage(
            messageElement,
            '✓ You’re already on the notification list.',
            'info'
          );


        } else if (
          result.success &&
          result.status ===
          're_subscribed'
        ) {

          showMessage(
            messageElement,
            '✓ You’re back on the notification list.',
            'success'
          );


        } else if (
          result.success
        ) {

          showMessage(
            messageElement,
            '✓ We’ll notify you when it’s back.',
            'success'
          );


          form.reset();


        } else {

          throw new Error(
            result.error ||
            'Something went wrong.'
          );

        }


      } catch (error) {

        console.error(
          'Notify Me submission error:',
          error
        );


        showMessage(
          messageElement,
          'Something went wrong. Please try again.',
          'error'
        );


      } finally {

        setSubmitting(
          submitButton,
          false
        );

      }

    }


    /* =========================================================
       CLICK HANDLER
       ========================================================= */

    document.addEventListener(
      'click',
      function (event) {

        /*
          OPEN
        */

        const openButton =
          event.target.closest(
            '[data-notify-open]'
          );


        if (openButton) {

          event.preventDefault();

          event.stopPropagation();


          openNotifyPopup(
            openButton.dataset.notifyOpen,
            openButton
          );


          return;

        }


        /*
          CLOSE BUTTON
        */

        const closeButton =
          event.target.closest(
            '[data-notify-close]'
          );


        if (closeButton) {

          event.preventDefault();

          event.stopPropagation();


          closeNotifyPopup(
            closeButton.dataset.notifyClose,
            true
          );


          return;

        }


        /*
          BACKDROP CLICK
        */

        if (
          activeOverlay &&
          event.target === activeOverlay
        ) {

          closeNotifyPopup(
            activeOverlay.dataset.notifyOverlay,
            true
          );

        }

      }
    );


    /* =========================================================
       FORM SUBMIT
       ========================================================= */

    /*
      Capture mode prevents Dawn product-form.js
      from processing this form.
    */

    document.addEventListener(
      'submit',
      function (event) {

        const form =
          event.target.closest(
            '[data-notify-form]'
          );


        if (!form) return;


        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        submitNotifyForm(
          form
        );

      },
      true
    );


    /* =========================================================
       REMOVE ERROR STATE WHILE USER TYPES
       ========================================================= */

    document.addEventListener(
      'input',
      function (event) {

        if (
          event.target.matches(
            '.notify-form input'
          )
        ) {

          event.target.classList.remove(
            'notify-input-error'
          );

        }

      }
    );


    /* =========================================================
       ESCAPE TO CLOSE
       ========================================================= */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !== 'Escape' ||
          !activeOverlay
        ) {

          return;

        }


        closeNotifyPopup(
          activeOverlay.dataset.notifyOverlay,
          true
        );

      }
    );


  })();